import React, { useEffect, useState } from 'react';
import TableWithSkeleton from '../../../components/global/table/TableWithSkeleton';
import Pagination from "../../../components/global/pagination/Pagination.jsx";
import ModalComponent from '../../../components/global/modal/ModalComponent.jsx';
import columns from '../../../columns/ibApproved/reject.js';
import { GetAllibApi, GetAllIBByIdApi } from "../../../api/request/ibapproved.js";
import moment from "moment";
import Eye from '../../../assets/Eye.jsx';
import { Spin } from 'antd';
import { useSelector } from 'react-redux';
import UserAvatar from '../../../components/global/avtar/UserAvatar.jsx';

export default function IbReject({ dates }) {

    const userDetails = useSelector((state) => state.user.userDetails);
    let isSalesManager = userDetails?.roleId === 6;

    const [pageSize, setPageSize] = useState(10);
    const [page, setPage] = useState(1);
    const [isLoading, setIsLoading] = useState(false);
    const [isReject, setIsReject] = useState(false);
    const [isLoadingIBDetails, setIsLoadingIBDetails] = useState(false);
    const [totalRecord, setTotalRecord] = useState(0);
    const [data, setData] = useState([]);
    const [selectedIBId, setSelectedIBId] = useState('');
    const [iBDetails, setIBDetails] = useState({});
    const [sorter, setSorter] = useState({ SortBy: 'actionDate', SortOrder: '' });

    const getAllIB = async () => {
        try {
            let params = {
                PageNumber: page,
                PageSize: pageSize,
                SearchText: dates,
                FilterText: "Rejected",
                ...sorter
            }
            setIsLoading(true);
            const { data } = await GetAllibApi(new URLSearchParams(params).toString());
            if (data?.success) {
                setData(
                    data?.data?.map((item) => {
                        return {
                            ...item,
                            name: (<UserAvatar data={{ name: `${item?.firstName} ${item?.lastName}`, email: item?.email}} />),
                            requestDate: (item?.requestDate ? moment(item?.requestDate).format("DD-MM-YYYY hh:mm A") : null),
                            actionDate: (item?.actionDate ? moment(item?.actionDate).format("DD-MM-YYYY, hh:mm A") : null),
                            action: (<button type="button" onClick={() => { setSelectedIBId(item?.userId); setIsReject(true) }}><Eye /></button>),
                        };
                    })
                );
                setTotalRecord(data?.totalRecords);
            }
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
        }
    }
    const handleTableChange = (pagination, filters, sorter) => {
        if (sorter?.order) {
            setSorter({ SortBy: sorter?.field, SortOrder: sorter?.order });
        } else {
            setSorter({ SortBy: 'actionDate', SortOrder: '' });
        }
    };

    useEffect(() => {
        getAllIB();
    }, [page, pageSize, sorter, dates]);

    useEffect(() => {
        setPage(1);
    }, [dates]);

    const getIBById = async () => {
        try {
            setIsLoadingIBDetails(true);
            const { data } = await GetAllIBByIdApi(selectedIBId);
            setIBDetails(data?.data);
            setIsLoadingIBDetails(false);
        } catch (error) {
            setIsLoadingIBDetails(false);
        }
    }

    useEffect(() => {
        if (selectedIBId) {
            getIBById();
        }
    }, [selectedIBId]);
    return (
        <>
            {/* Reject table */}
            <div className="my-6">
                    <div className="border border-gray-200 rounded-xl overflow-hidden bg-white">
                        <TableWithSkeleton
                            columns={columns}
                            data={data}
                            loading={isLoading}
                            onChange={handleTableChange}
                            hiddenColumns={isSalesManager ? ["Actions"] : []}
                            page={page}
                            pageSize={pageSize}
                            index={true}
                        />
                    </div>
                <Pagination total={totalRecord} pageSize={pageSize} setPageSize={setPageSize} page={page} setPage={setPage} />
            </div>

            {/* Reject Modal */}
            <ModalComponent isOpen={isReject} setIsOpen={setIsReject} title='IB Details' width={1300}>
                {
                    isLoadingIBDetails ? (
                        <div className="flex justify-center flex-col my-[5%]">
                            <Spin size="large" />
                            <p className="primary text-center mt-2">Loading...</p>
                        </div>
                    ) : (
                        <div className='p-5'>
                            <div className='grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 gap-10 '>
                                <div>
                                    <p className='text-description font-normal '>First Name</p>
                                    <p className='text-description primary font-semibold  mt-2'>{iBDetails?.firstName}</p>
                                </div>
                                <div>
                                    <p className='text-description font-normal '>Last Name</p>
                                    <p className='text-description primary font-semibold  mt-2'>{iBDetails?.lastName}</p>
                                </div>
                                <div>
                                    <p className='text-description font-normal '>Mobile No.</p>
                                    <p className='text-description primary font-semibold  mt-2'>{iBDetails?.phoneNo}</p>
                                </div>
                                <div>
                                    <p className='text-description font-normal '>Email</p>
                                    <p className='text-description primary font-semibold  mt-2'>{iBDetails?.email}</p>
                                </div>
                                <div>
                                    <p className='text-description font-normal '>Request Time</p>
                                    <p className='text-description primary font-semibold  mt-2'>{iBDetails?.requestDate ? moment(iBDetails?.requestDate).format('DD-MM-YYYY, hh:mm A') : '--'}</p>
                                </div>
                                <div>
                                    <p className='text-description font-normal '>Decline Time</p>
                                    <p className='text-description primary font-semibold  mt-2'>{iBDetails?.actionDate ? moment(iBDetails?.actionDate).format('DD-MM-YYYY, hh:mm A') : '--'}</p>
                                </div>
                                <div>
                                    <p className='text-description font-normal '>IB User</p>
                                    <p className='text-description primary font-semibold  mt-2'>{iBDetails?.isIBUser === true ? "yes" : "No"}</p>
                                </div>
                                <div>
                                    <p className='text-description font-normal '>Declined by </p>
                                    <p className='text-description primary font-semibold  mt-2'>{iBDetails?.actionBy}</p>
                                </div>
                                <div>
                                    <p className='text-description font-normal '>Comment</p>
                                    <p className='text-description primary font-semibold  mt-2'>{iBDetails?.comment}</p>
                                </div>
                            </div>
                        </div>
                    )
                }
            </ModalComponent>
        </>
    )
}
